var _defs, _rect, _circle, _ellipse, _ellipse2, _ellipse3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 50,
    viewBox: "0 0 180 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgMain",
    x1: 0,
    y1: 0,
    x2: 46,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a0e1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o1m",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#541530",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#c44070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#c44070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#541530",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o2m",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8c2d4a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#e8709a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#e8709a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8c2d4a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nucleusM",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ffb8d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d4547a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glowM",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "glowSM",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1.2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 44,
    height: 44,
    rx: 12,
    fill: "url(#bgMain)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 18,
    fill: "#541530",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 25,
    rx: 16,
    ry: 6.5,
    transform: "rotate(-40 23 25)",
    fill: "none",
    stroke: "url(#o1m)",
    strokeWidth: 1.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 25,
    rx: 16,
    ry: 6.5,
    transform: "rotate(40 23 25)",
    fill: "none",
    stroke: "url(#o2m)",
    strokeWidth: 1.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 25,
    rx: 16,
    ry: 6.5,
    transform: "rotate(90 23 25)",
    fill: "none",
    stroke: "url(#o1m)",
    strokeWidth: 1,
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 25,
    r: 2.5,
    fill: "#e8709a",
    filter: "url(#glowM)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 20.5,
    r: 2,
    fill: "#c44070",
    filter: "url(#glowM)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 9.5,
    r: 2,
    fill: "#a33b5c",
    filter: "url(#glowSM)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 5.5,
    fill: "#541530",
    opacity: 0.5,
    filter: "url(#glowM)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 4.2,
    fill: "url(#nucleusM)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 2,
    fill: "white",
    opacity: 0.95
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 24,
    fontFamily: "'Inter', 'Segoe UI', Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: -0.3
  }, "Sales")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 24,
    fontFamily: "'Inter', 'Segoe UI', Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 300,
    fill: "#d4547a",
    letterSpacing: -0.3
  }, " AI")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 37,
    fontFamily: "'Inter', 'Segoe UI', Helvetica, sans-serif",
    fontSize: 8,
    fontWeight: 500,
    fill: "#d4c0c8",
    letterSpacing: 3.5,
    opacity: 0.7
  }, "PLATFORM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4f2b50e791369acd4a548031d8ec485.svg";
export { ForwardRef as ReactComponent };